<template>
  <div class="pop" v-show="show" @click.stop='_=>{}'>
    <div class="box" ref='iframeWrap'>
      <div id="close" class="close_btn" @click="close"></div>
      <iframe :src="url" frameborder="0" width="642" height="271" ref="iframe" class="iframe"></iframe>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src

  export default {
    name: 'alert',
    data: () => ({
      show: true,
      spanClick: 'CloseClick'
    }),
    props: {
      url: {
        default: '',
        type: String
      }
    },
    methods: {
      close() {
        this.show = false
      }
    },
    created() {
      let _this = this

      window[this.spanClick] = (params) => {

        _this.close()    

      }
    },
    components: {

    },
    mounted() {
      let self = this
      this.$refs.iframe.onload = function () {
        self.$refs.iframeWrap.style.marginLeft = -1 * self.$refs.iframeWrap.offsetWidth / 2 + 'px'
        self.$refs.iframeWrap.style.marginTop = -1 * self.$refs.iframeWrap.offsetHeight / 2 + 'px'
      }
    }
  }
</script>

<style scoped>
  .pop {
    position: fixed;
    z-index: 2000;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .2);
  }

  .box {
    position: absolute;
    left: 50%;
    top: 50%;
  }

  .close_btn {
    background: url(../assets/image/cha_red.png) no-repeat;
    position: absolute;
    width: 36px;
    height: 36px;
    right: -6px;
    top: -6px;
    z-index: 9;
    cursor: pointer;
  }
</style>